(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[237],{

/***/ "CSWM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/cms/toolkit/constants.js
var constants = __webpack_require__("psNz");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.mapper.js + 1 modules
var Product_mapper = __webpack_require__("bGCG");

// EXTERNAL MODULE: ./src/client/components/widgets/product-teaser/ProductTeaser.jsx
var ProductTeaser = __webpack_require__("GjC5");

// CONCATENATED MODULE: ./src/client/components/lines/product-related-products-line/ProductRelatedProductsLine.jsx


var __jsx = react_default.a.createElement;







var ProductRelatedProductsLine_ProductRelatedProductsLine = function ProductRelatedProductsLine(_ref) {
  var _product$relatedProdu;

  var config = _ref.config,
      product = _ref.product,
      title = _ref.title;

  if (!(product === null || product === void 0 ? void 0 : (_product$relatedProdu = product.relatedProducts) === null || _product$relatedProdu === void 0 ? void 0 : _product$relatedProdu.length)) {
    return null;
  }

  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-RelatedProducts"
  }, __jsx(LineTitle["a" /* LineTitle */], null, title), product.relatedProducts.map(function (relatedProduct, index) {
    var card = {
      color: colors["a" /* COLORS */].SAFFRON,
      heading: {
        iconName: relatedProduct.resortId.toLowerCase(),
        title: relatedProduct.name
      },
      link: {
        url: relatedProduct.href
      },
      text: {
        text: relatedProduct.title
      }
    };
    return __jsx("article", {
      key: relatedProduct.id,
      className: "Line Line-ProductTeaser"
    }, __jsx(ProductTeaser["a" /* ProductTeaser */], {
      card: card,
      index: index,
      lineName: constants["bb" /* RELATED_PRODUCTS */],
      product: Object(Product_mapper["c" /* getProductProps */])({
        config: config,
        product: relatedProduct
      })
    }));
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-related-products/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductRelatedProductsLine_ProductRelatedProductsLine);

/***/ })

}]);